import React, { Component } from 'react';
import Modal from 'react-modal';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
// import renderIf from 'render-if';
import PropTypes from 'prop-types';
import UpgradeTiles from 'components/UpgradeTiles';
import styles from './UpgradePopup.scss';// to import local scss fle

class PlanModel extends Component {
  static propTypes = {
    showTrialButton: PropTypes.bool.isRequired,
  };
  static defaultProps = {
    history: {
      push: () => {},
    },
  };
  constructor(props) {
    super(props);
    this.onOpenModal = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.state = {
      open: true,
      title: '',
    };
  }
  componentWillMount() {
    const paymentStatus = window.sessionStorage.getItem('kiro');
    this.setState({ payment: paymentStatus });
  }

  componentWillReceiveProps() {
    const paymentStatus = window.sessionStorage.getItem('kiro');
    this.setState({ payment: paymentStatus });
  }
  componentWillUnmount() {
    this.setState({ open: false });
  }
  onOpenModal() {
    this.setState({ open: true });
  }

  onCloseModal() {
    this.setState({ open: false });
  }

  render() {
    const modalStyle = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        minHeight: '300px',
        transform: 'translate(-50%, -50%)',
      },
    };
    const { open } = this.state;
    // let getTotalCountsCompleted = false;
    // if (this.props.totalCounts.size > 0) {
    //   getTotalCountsCompleted = true;
    // }
    // const renderModal = renderIf(getTotalCountsCompleted);
    return (
      <div>
        {/* <button onClick={this.onOpenModal}>BUY NOW</button> */}
        {/* eslint-disable */}

        <Modal style={modalStyle} isOpen={open} onRequestClose={this.onCloseModal} >
            <div className={cn('row', styles.container)}>
                <div className={styles.absoluteCross} onClick={this.onCloseModal}>
                    x
                </div>
                <div className={cn('col s12', styles.header)} >
                    UPGRADE
                </div>
                <div className={cn('col s12')} >
                    <UpgradeTiles {...this.props} showTrialButton={this.props.showTrialButton} />
                </div>
            </div>
            {/* eslint-disable */}
        </Modal>
      </div>
        );
    }
}

export default PlanModel;



// WEBPACK FOOTER //
// ./src/components/UpgradePopup/UpgradePopup.js